import { hasLineBreakMarkers } from './normalizeTextLineBreaksByDevice';

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  Object.prototype.toString.call(value) === '[object Object]';

/** Быстрая проверка: есть ли в дереве маркеры [BREAK_MOBILE] / [BREAK_DESKTOP]. */
export const hasLineBreakMarkersInTree = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return hasLineBreakMarkers(value);
  }

  if (Array.isArray(value)) {
    return value.some(hasLineBreakMarkersInTree);
  }

  if (!isPlainObject(value)) {
    return false;
  }

  return Object.values(value).some(hasLineBreakMarkersInTree);
};
